const entity = {
  // eslint-disable-next-line
  process(structure, formData) {
    return structure;
  },
};

export default entity;
